@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if (typeof $.row?.status === 'string') {
    @switch ($.row.status.toLowerCase()) {
      @case ('active') {
        <p-tag
          styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
          severity="success">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('inactive') {
        <p-tag
          styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('completed') {
        <p-tag
          severity="success"
          styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('created') {
        <p-tag
          severity="info"
          styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('presales') {
        <p-tag
          styleClass="text-xxs bg-indigo-600 uppercase white-space-nowrap"
          severity="success">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('draft') {
        <p-tag
          styleClass="text-xxs uppercase white-space-nowrap"
          severity="contrast">
          {{ $.row.status }}
        </p-tag>
      }
      @case ('inprogress') {
        <p-tag
          styleClass="text-xxs uppercase white-space-nowrap"
          severity="info">
          {{ $.row.status }}
        </p-tag>
      }
      @default {
        <p-tag
          styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
          severity="secondary">
          {{ $.row.status }}
        </p-tag>
      }
    }
  } @else if (typeof $.row?.status === 'boolean' && $.row.status) {
    <p-tag
      styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
      severity="success">
      Active
    </p-tag>
  } @else if (typeof $.row?.status === 'boolean' && !$.row.status) {
    <p-tag
      styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">
      Inactive
    </p-tag>
  } @else if (hasKeyInObject($.row, 'is_active') && $.row?.is_active) {
    <p-tag
      styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
      severity="success">
      Active
    </p-tag>
  } @else if (hasKeyInObject($.row, 'isActive') && $.row?.isActive) {
    <p-tag
      styleClass="p-mr-2 text-xxs font-normal uppercase white-space-nowrap"
      severity="success">
      Active
    </p-tag>
  } @else if (hasKeyInObject($.row, 'is_active') && !$.row?.is_active) {
    <p-tag
      styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">
      Inactive
    </p-tag>
  } @else if (hasKeyInObject($.row, 'isActive') && !$.row?.isActive) {
    <p-tag
      styleClass="p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap">
      Inactive
    </p-tag>
  }
}
